import clsx from 'clsx'
import { PercentagePoint, Table } from 'components/core-v2'
import Highcharts from 'highcharts'
import sunburst from 'highcharts/modules/sunburst.js'
import { ClassName } from 'types/props'
import { formatCurrencyFull } from 'utilities/currency'

import { SunburstChart } from '../sunburst-chart'
import { ChartOptionsProps } from '../sunburst-chart/chart-options'
import classes from './index.module.scss'
import { COLUMN_DEFS, DEFAULT_COLUMN_DEFS } from './table-options'

export * from './loading'

sunburst(Highcharts)

interface Props extends ClassName, Omit<ChartOptionsProps<PercentagePoint>, 'tooltipFormatter'> {
  nameHeading?: string
  tableWidth?: string
}

export const AmountSunburstWithTable = ({
  allowTooltipOutside,
  className,
  data,
  nameHeading,
  seriesName,
  tableWidth = '100%'
}: Props) => (
  <div className={clsx('center', className)}>
    <div className={classes.chartWrapper}>
      <SunburstChart
        allowTooltipOutside={allowTooltipOutside}
        data={data}
        seriesName={seriesName}
        tooltipFormatter={that => {
          const { point, series } = that
          const { name, value } = point as unknown as PercentagePoint

          return `<div class="sunburst-chart-tooltip-wrapper"><h2>${
            series.name
          }</h2><p>${name}</p><p>${formatCurrencyFull(value, 'ZAR')}</p></div>`
        }}
      />
    </div>
    <Table
      agGridProps={{
        columnDefs: COLUMN_DEFS(nameHeading),
        defaultColDef: DEFAULT_COLUMN_DEFS,
        headerHeight: 60,
        rowData: data,
        rowHeight: 44
      }}
      className={classes.tableWrapper}
      width={tableWidth}
    />
  </div>
)
